/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openFinanceSlideout } from '../../actions/lister-actions';
import { FinanceInstallments } from './FinanceInstallments';
import { buildSlideoutPayload } from '../../utilities/finance-utilities';

const FinanceWithChevron = ({
	NewDayFinanceQuote,
	MemberPrice,
	NowPrice,
	Code,
	ColourId,
	PromotionType,
	PromotionMonths,
	financePromotions,
	State,
	useOldPricePod,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false,
	},
	isSwitch24Product,
	Switch24Pricing,
	representativeAprRateString,
	purchaseAprRateString,
	useEnhancedFinanceProposition,
	isFinancePromotion,
}) => {
	const dispatch = useDispatch();

	const {
		AnnualMembershipFee,
		DeliveryPricingInPricePod,
		UseUpfrontPricingAmounts,
		UseSwitch24,
	} = useSelector((state) => state.featureSwitches);

	const slideoutPayload = buildSlideoutPayload({
		ColourId,
		Code,
		NowPrice,
		MemberPrice,
		AnnualMembershipFee,
		PromotionType,
		PromotionMonths,
		FinancePromotions: financePromotions,
		State,
		UpfrontPricing,
		Switch24Pricing,
		UseUpfrontPricingAmounts,
		UseSwitch24,
		representativeAprRateString,
		purchaseAprRateString,
	});

	const openFinanceSlideoutWithPayload = () => {
		dispatch(openFinanceSlideout(slideoutPayload));
	};

	const switchMonthlyPayment =
		Switch24Pricing?.Switch24FinanceQuote?.MonthlyPayment;

	const enhancedWrapperClass =
		'text-left leading-tight text-body-xs z-10 relative';
	const legacyWrapperClass =
		'cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative';

	const installmentsProps = {
		UpfrontPricing,
		UseUpfrontPricingAmounts,
		DeliveryPricingInPricePod,
		NewDayFinanceQuote,
		isSwitch24Product,
		switchMonthlyPayment,
		useEnhancedFinanceProposition,
		isFinancePromotion,
	};

	if (useEnhancedFinanceProposition) {
		return (
			<div
				aria-label="Instalments Finance Promotion"
				className={enhancedWrapperClass}
				data-tag-name="non-member-display-monthly-installments-button"
				data-testid="non-member-lister-finance-instalments">
				<FinanceInstallments {...installmentsProps} />
				<div
					className="font-bold text-link cursor-pointer text-xs"
					role="link"
					tabIndex={0}
					onClick={openFinanceSlideoutWithPayload}
					data-testid="finance-learn-more-link">
					Learn more
				</div>
			</div>
		);
	}

	return useOldPricePod ? (
		<div
			aria-label="Instalments Finance Promotion"
			className={`${legacyWrapperClass} mt-1`}
			tabIndex={0}
			role="link"
			onClick={openFinanceSlideoutWithPayload}
			data-tag-name="member-price-monthly-installments-button"
			data-testid="finance-instalments">
			<FinanceInstallments {...installmentsProps} />
		</div>
	) : (
		<div
			aria-label="Instalments Finance Promotion"
			className={`ml-0 ${legacyWrapperClass} ${isSwitch24Product ? 'mb-0' : 'mb-3'}`}
			tabIndex={0}
			role="link"
			onClick={openFinanceSlideoutWithPayload}
			data-tag-name="non-member-display-monthly-installments-button"
			data-testid="non-member-lister-finance-instalments">
			<FinanceInstallments {...installmentsProps} />
		</div>
	);
};

export default FinanceWithChevron;
